<template>
    <div class="component-root">
        <h1>{{resource('JourneyBuilder_JourneyReport_Title')}}</h1>
        
        <!-- Button needs to be wrapped in a div to prevent it from stretching to full width -->
        <div class="row">
            <div class="col-auto">
                <navigate-to-journey-button :journey-id="journeyId" :disabled="!journeyId" />    
            </div>

            <div class="col-auto">
                <navigate-to-overview-button />
            </div>
        </div>
        
        <bootstrap-box>
            <template #header>
                <div class="mb-3">
                    <i class="fas fa-project-diagram"/>
                    <h3 class="box-title">{{resource('JourneyBuilder_JourneyReport_Title')}}</h3>
                </div>
                
                <journey-statistics-configuration />
            </template>
            <template #body>
                <div class="form-group">
                    <div class="row">
                        <div class="col-12">
                            <journey-statistics-sankey v-if="isReady" />
                        </div>
                    </div>
                </div>
            </template>
        </bootstrap-box>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    import resourceMixin from "@core/Util/Mixins/resources";

    import BootstrapBox from "@core/Components/Util/BootstrapBox";
    import NavigateToOverviewButton from "@modules/JourneyBuilder/Components/Elements/NavigateToOverviewButton";
    import NavigateToJourneyButton from "@modules/JourneyBuilder/Components/Elements/NavigateToJourneyButton";
    import JourneyStatisticsConfiguration from "./JourneyStatisticsConfiguration";
    import JourneyStatisticsSankey from "./JourneyStatisticsSankey";
    
    const { mapState, mapGetters, mapMutations } = createNamespacedHelpers('journeyBuilder/reporting');

    export default {
        name: 'journey-statistics-overview',
        components: {
            JourneyStatisticsConfiguration,
            JourneyStatisticsSankey,

            BootstrapBox, 
            NavigateToOverviewButton,
            NavigateToJourneyButton
        },
        created() {
            const initialJourneyId = this.$route && this.$route.params.id;
            if(initialJourneyId){
                this.setJourneyId(initialJourneyId);
            }

            //Read highlightedBrickId from querystring
            const {highlightedBrickId: preSelectedBrickId} = (this.$route && this.$route.query) || {};
            
            //Preselect highlightedBrickId on initial dataset load
            if(preSelectedBrickId){
                this.setSelectedBrickId(preSelectedBrickId);   
            }
        },
        mixins: [resourceMixin],
        methods: {
            ...mapMutations(['setJourneyId', 'setSelectedBrickId'])
        },
        computed: {
            ...mapState(['sankeyData', 'journeyId']),
            ...mapGetters({
                isReady: 'canLoadSankeyData'
            })
        }
    }
</script>

<style scoped>
    .component-root {
        display: flex;
        flex-flow: column;
        row-gap: 10px;
    }
</style>